
/**
 * 14Agency – Shipping Bar & Request a Quote
 * Shopify Dawn / SparkLayer / B2B und B2C
 *
 * Preisgrundlage:
 * - Bruttopreise inkl. 19 % USt.
 * - Versandfreigrenze: 350 EUR netto
 * - Request a Quote: ab 350 EUR Warenkorbwert (cart.total_price nach Rabatten)
 * - Deutschland: 11,90 EUR netto Fracht
 * - Ausland: 0 EUR Fracht
 *
 * Mindermengenzuschlag:
 * - Bis 100 EUR netto: 10 EUR
 * - Über 100 bis 200 EUR netto: 5 EUR
 * - Über 200 EUR netto: 0 EUR
 *
 * Hinweis:
 * - Nur Anzeige, keine Checkout-Gebührenerhebung
 * - Request a Quote wird nur visuell gesteuert (data-quote-eligible)
 * - Versandkostenleiste: Netto (Brutto / 1,19)
 * - Quote-Schwelle: cart.total_price in Cent
 */

(() => {
  "use strict";

  if (window.__a14ShippingBarLoaded) return;
  window.__a14ShippingBarLoaded = true;

  const CONFIG = {
    vatFactor: 1.19,

    firstLimit: 10000,
    secondLimit: 20000,
    freeShippingLimit: 35000,

    // Quote: Warenkorb-Gesamtwert nach Rabatten (cart.total_price), nicht Netto
    quoteMinimum: 35000,

    surchargeFirst: 1000,
    surchargeSecond: 500,

    shippingGermany: 1190,
    shippingAbroad: 0,

    progressStartColor: "#1f8fce",
    progressEndColor: "#0b5e9e",
    progressBackground: "#d6d6d6"
  };

  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR"
  });

  const money = cents =>
    formatter.format(cents / 100);

  const getBars = () =>
    document.querySelectorAll(
      "[data-free-shipping-bar]"
    );

  const getCartFooter = () =>
    document.querySelector("#main-cart-footer");

  const isPunchout = () =>
    window.location.href
      .toLowerCase()
      .includes("punchout");

  /**
   * Request a Quote standardmäßig ausblenden.
   */
  function hideQuoteButton() {
    const footer = getCartFooter();

    if (footer) {
      footer.dataset.quoteEligible = "false";
    }
  }

  /**
   * Shipping Bars und Quote Button ausblenden.
   */
  function hideBars() {
    getBars().forEach(bar => {
      bar.hidden = true;
    });

    hideQuoteButton();
  }

  /**
   * Bruttopreis in Nettowarenwert umrechnen.
   * Alle Werte werden in Cent verarbeitet.
   *
   * Voraussetzung: Einheitlicher Steuersatz 19 %.
   */
  function calculateNetTotal(cart) {
    const grossCents = Number(cart.total_price);

    if (!Number.isFinite(grossCents)) {
      return null;
    }

    return Math.round(
      grossCents / CONFIG.vatFactor
    );
  }

  /**
   * Request a Quote anhand von cart.total_price (nach Rabatten)
   * ein- oder ausblenden. Bestehende Zusatzbedingungen bleiben:
   * kein Punchout, Artikel im Warenkorb, Währung EUR.
   *
   * Ab 350,00 EUR total_price: sichtbar
   * Unter 350,00 EUR: ausgeblendet
   */
  function updateQuoteButton(cart) {
    const footer = getCartFooter();

    if (!footer) return;

    const currency = cart.currency || "EUR";
    const totalPrice = Number(cart.total_price);

    const isEligible =
      !isPunchout() &&
      cart.item_count > 0 &&
      currency === "EUR" &&
      Number.isFinite(totalPrice) &&
      totalPrice >= CONFIG.quoteMinimum;

    footer.dataset.quoteEligible = String(isEligible);
  }

  /**
   * Versand und Zuschläge berechnen.
   */
  function calculateShipping(netTotal, country) {
    let surcharge = 0;

    if (netTotal <= CONFIG.firstLimit) {
      surcharge = CONFIG.surchargeFirst;
    } else if (netTotal <= CONFIG.secondLimit) {
      surcharge = CONFIG.surchargeSecond;
    }

    const freeShipping =
      netTotal >= CONFIG.freeShippingLimit;

    let freight = country === "DE"
      ? CONFIG.shippingGermany
      : CONFIG.shippingAbroad;

    if (freeShipping) {
      freight = 0;
    }

    const remaining = Math.max(
      0,
      CONFIG.freeShippingLimit - netTotal
    );

    const progress = Math.min(
      100,
      Math.max(
        0,
        (netTotal / CONFIG.freeShippingLimit) * 100
      )
    );

    return {
      surcharge,
      freight,
      remaining,
      progress,
      freeShipping
    };
  }

  /**
   * Fortschrittsbalken aktualisieren.
   *
   * Der Hintergrund wird direkt gesetzt,
   * um CSS-Konflikte mit Dawn zu vermeiden.
   */
  function updateProgress(progressBar, progress) {
    if (!progressBar) return;

    const percentage = Math.min(
      100,
      Math.max(0, Number(progress) || 0)
    );

    const value = percentage.toFixed(4) + "%";

    progressBar.style.setProperty(
      "--a14-progress",
      value
    );

    const gradient =
      `linear-gradient(to right, ` +
      `${CONFIG.progressStartColor} 0%, ` +
      `${CONFIG.progressEndColor} ${value}, ` +
      `${CONFIG.progressBackground} ${value}, ` +
      `${CONFIG.progressBackground} 100%)`;

    progressBar.style.setProperty(
      "background",
      gradient,
      "important"
    );

    progressBar.setAttribute(
      "aria-valuenow",
      String(Math.round(percentage))
    );
  }

  /**
   * Einzelne Versandkostenleiste aktualisieren.
   */
  function updateBar(bar, cart) {
    if (isPunchout() || !cart.item_count) {
      bar.hidden = true;
      return;
    }

    const currency =
      cart.currency ||
      bar.dataset.currency ||
      "EUR";

    if (currency !== "EUR") {
      bar.hidden = true;
      return;
    }

    const netTotal = calculateNetTotal(cart);

    if (netTotal === null) {
      bar.hidden = true;
      return;
    }

    const country =
      bar.dataset.country || "DE";

    const result = calculateShipping(
      netTotal,
      country
    );

    const progressBar = bar.querySelector(
      ".free-shipping-bar-progress"
    );

    const mainText = bar.querySelector(
      ".free-shipping-text"
    );

    const subText = bar.querySelector(
      ".free-shipping-subtext"
    );

    const extraText = bar.querySelector(
      ".free-shipping-extra"
    );

    if (
      !progressBar ||
      !mainText ||
      !subText ||
      !extraText
    ) {
      console.warn(
        "[14Agency] Shipping Bar: HTML-Elemente fehlen."
      );

      return;
    }

    // Fortschritt aktualisieren
    updateProgress(
      progressBar,
      result.progress
    );

    // Haupttext
    if (result.freeShipping) {
      mainText.textContent =
        "Kostenloser Versand erreicht!";
    } else {
      mainText.textContent =
        `Noch ${money(result.remaining)} netto ` +
        "bis zum kostenlosen Versand.";
    }

    // Frachtkosten
    if (result.freight > 0) {
      subText.textContent =
        `Frachtkosten: ${money(result.freight)} netto`;
    } else {
      subText.textContent =
        "Keine Frachtkosten";
    }

    // Mindermengenzuschlag
    if (result.surcharge > 0) {
      extraText.textContent =
        `Mindermengenzuschlag: ` +
        `${money(result.surcharge)} netto`;
    } else {
      extraText.textContent =
        "Kein Mindermengenzuschlag";
    }

    bar.hidden = false;
  }

  let refreshTimer = null;
  let requestId = 0;

  /**
   * Aktuellen Warenkorb von Shopify abrufen.
   *
   * Shipping Bar und Request a Quote werden
   * mit denselben Daten aktualisiert.
   */
  async function refreshBars() {
    const currentRequest = ++requestId;

    if (isPunchout()) {
      hideBars();
      return;
    }

    if (!getBars().length && !getCartFooter()) {
      return;
    }

    try {
      const root =
        window.Shopify?.routes?.root || "/";

      const cartUrl =
        root.replace(/\/?$/, "/") + "cart.js";

      const response = await fetch(cartUrl, {
        method: "GET",
        credentials: "same-origin",
        cache: "no-store",
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(
          `Cart API: ${response.status}`
        );
      }

      const cart = await response.json();

      // Veraltete Antworten ignorieren
      if (currentRequest !== requestId) {
        return;
      }

      // Shipping Bar aktualisieren
      getBars().forEach(bar => {
        updateBar(bar, cart);
      });

      // Request a Quote aktualisieren
      updateQuoteButton(cart);

    } catch (error) {
      console.error(
        "[14Agency] Shipping Bar & Quote:",
        error
      );

      if (currentRequest === requestId) {
        hideBars();
      }
    }
  }

  /**
   * Aktualisierungen zusammenfassen.
   */
  function scheduleRefresh(delay = 200) {
    clearTimeout(refreshTimer);

    // Laufende alte Requests ungültig machen
    ++requestId;

    // Quote bis zur neuen Prüfung ausblenden
    hideQuoteButton();

    refreshTimer = setTimeout(() => {
      refreshBars();
    }, delay);
  }

  /**
   * Initialisierung.
   */
  function init() {
    // Liquid setzt data-quote-eligible serverseitig (Standard: ausgeblendet).
    // Kein sofortiges Ausblenden hier, um Flackern bei gültigem Warenkorb zu vermeiden.
    refreshBars();

    /**
     * 1. Dawn PubSub
     * Reagiert auf abgeschlossene Cart-Updates.
     */
    if (
      typeof window.subscribe === "function" &&
      window.PUB_SUB_EVENTS?.cartUpdate
    ) {
      window.subscribe(
        window.PUB_SUB_EVENTS.cartUpdate,
        () => scheduleRefresh(100)
      );
    }

    /**
     * 2. Mengenänderungen
     */
    document.addEventListener(
      "change",
      event => {
        if (!(event.target instanceof Element)) {
          return;
        }

        if (
          event.target.matches(
            '.quantity__input, ' +
            'input[name="updates[]"], ' +
            'input[data-quantity-variant-id]'
          )
        ) {
          scheduleRefresh(750);
        }
      }
    );

    /**
     * 3. Mengenbuttons und Entfernen
     */
    document.addEventListener(
      "click",
      event => {
        if (!(event.target instanceof Element)) {
          return;
        }

        const cartButton = event.target.closest(
          "cart-remove-button, " +
          ".quantity__button, " +
          "[data-cart-remove]"
        );

        if (cartButton) {
          scheduleRefresh(750);
        }
      }
    );

    /**
     * 4. Neu gerenderte Dawn-Bereiche erkennen.
     *
     * Eigene Änderungen an der Versandkostenleiste
     * und am Quote-Status lösen keine zusätzlichen
     * Aktualisierungen aus.
     */
    const cartSelectors = [
      "cart-drawer",
      "cart-items",
      "#CartDrawer",
      "#main-cart-items",
      "#main-cart-footer",
      "[data-free-shipping-bar]"
    ].join(",");

    const observer = new MutationObserver(
      mutations => {
        const relevant = mutations.some(mutation => {
          const target = mutation.target;

          if (!(target instanceof Element)) {
            return false;
          }

          // Eigene Versandkostenleiste ignorieren
          if (
            target.closest("[data-free-shipping-bar]")
          ) {
            return false;
          }

          return Array.from(
            mutation.addedNodes
          ).some(node => {
            if (!(node instanceof Element)) {
              return false;
            }

            return (
              node.matches(cartSelectors) ||
              Boolean(
                node.querySelector(cartSelectors)
              ) ||
              Boolean(
                target.closest(
                  "cart-drawer, cart-items, " +
                  "#CartDrawer, #main-cart-items, " +
                  "#main-cart-footer"
                )
              )
            );
          });
        });

        if (relevant) {
          scheduleRefresh(200);
        }
      }
    );

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    /**
     * 5. Zusätzliche Cart-Events
     */
    [
      "cart:updated",
      "cart:refresh",
      "cart:change"
    ].forEach(eventName => {
      document.addEventListener(
        eventName,
        () => scheduleRefresh(150)
      );
    });

    /**
     * 6. Browser-Navigation
     */
    window.addEventListener(
      "pageshow",
      () => scheduleRefresh(100)
    );

    /**
     * 7. Tab wieder sichtbar
     */
    document.addEventListener(
      "visibilitychange",
      () => {
        if (!document.hidden) {
          scheduleRefresh(100);
        }
      }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      { once: true }
    );
  } else {
    init();
  }
})();
